import './LoginSignup.css';
import { loginWithGoogle } from '../services/data';
import Navbar from './Navbar';
import Cookies from 'js-cookie';
import toast from 'react-hot-toast';
import { motion } from 'framer-motion';

export default function LoginSignup({ onLoginSuccess }) {

  const handleGetStarted = () => {
    const userDetailsCookie = Cookies.get('facereco_user_details');
    if (userDetailsCookie) {
      const userCookie = JSON.parse(userDetailsCookie);
      onLoginSuccess(userCookie);
    } else {
      handleLogin();
    }
  };

  const handleLogin = async () => {
    const loadingToast = toast.loading('Signing in with Google...');
    try {
      const response = await loginWithGoogle();
      if (response.name && response.email && response.picture && response.verified && response.message) {
        const userCookie = {
          name: response.name,
          email: response.email,
          picture: response.picture,
          verified: response.verified,
          message: response.message
        };
        Cookies.set('facereco_user_details', JSON.stringify(userCookie), { sameSite: 'Lax' });
        toast.success(`Welcome, ${response.name}!`, { id: loadingToast });
        onLoginSuccess(userCookie);
      }
    } catch (error) {
      console.error(error);
      toast.error('Failed to sign in. Please try again.', { id: loadingToast });
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    handleGetStarted()
  };

  const features = [
    {
      icon: '🔐',
      title: 'Secure Authentication',
      description: 'Securely log in using your Google account with Firebase authentication'
    },
    {
      icon: '📸',
      title: 'Real-time Detection',
      description: 'Detect and recognize faces in real-time with advanced AI models'
    },
    {
      icon: '⚙️',
      title: 'Customizable Models',
      description: 'Train and customize facial recognition models for your needs'
    },
    {
      icon: '📊',
      title: 'Analytics Dashboard',
      description: 'Manage and analyze your face recognition data with ease'
    }
  ];

  return (
    <div className="landing-page">
      <Navbar OnGetStarted={handleGetStarted} />

      <div className="hero-section">
        <motion.h1
          className="hero-title"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
        >
          Welcome to FaceReco
        </motion.h1>

        <motion.h2
          className="hero-subtitle"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.2 }}
        >
          Unlock New Possibilities with Facial Recognition
        </motion.h2>

        <motion.p
          className="hero-description"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.4 }}
        >
          Build powerful applications that can understand and recognize human faces
          with cutting-edge AI technology. Fast, secure, and easy to use.
        </motion.p>

        <motion.button
          className="cta-button"
          onClick={handleSubmit}
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.6 }}
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
        >
          <span>Get Started</span>
          <span>→</span>
        </motion.button>
      </div>

      <div className="features-grid">
        {features.map((feature, index) => (
          <motion.div
            key={index}
            className="feature-card"
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.8 + index * 0.2 }}
            whileHover={{ y: -8 }}
          >
            <div className="feature-icon">{feature.icon}</div>
            <h3 className="feature-title">{feature.title}</h3>
            <p className="feature-description">{feature.description}</p>
          </motion.div>
        ))}
      </div>

      <div className="landing-footer">
        <p>© 2024 FaceReco. All rights reserved.</p>
      </div>
    </div>
  );
}
